// extracted by mini-css-extract-plugin
export default {"wrapper":"BoardInfo_wrapper__Q-r2d","empty":"BoardInfo_empty__e1K9W"};